import { useQuery } from '@tanstack/react-query'

import { StaleTime } from '@core/query'
import { type TCollectionSuggestions } from '@core/models'
import { CollectionQueryKey } from '../helpers/queryKeys'

import { getCollectionSuggestions } from '../services/getCollectionSuggestions'

type TUseCollectionSuggestionsParams = {
    username: string
    slug: string
    /** Seeded from the SSR loader so the first render matches the server without a refetch. */
    initialData?: TCollectionSuggestions
}

export const useCollectionSuggestions = ({
    username,
    slug,
    initialData,
}: TUseCollectionSuggestionsParams) => {
    return useQuery({
        queryKey: CollectionQueryKey.collectionSuggestions(username, slug),
        queryFn: ({ signal }) => getCollectionSuggestions({ username, slug, signal }),
        initialData,
        enabled: Boolean(username && slug),
        staleTime: StaleTime.Short,
    })
}
